import React from 'react';
import { Link } from 'react-router-dom';
import myresume from '../PDF/Resume of Mamunur Rashid Farabi.pdf';

const Hero = () => {
    return (
        <div>
            <div className="hero min-h-screen ">
                <div className="hero-content text-center">
                    <div className="max-w-md">
                        <h1 className="text-5xl font-bold">Welcome to my Portfolio Site</h1>
                        <p className="py-6">This is the platform to showcase my best project to you.</p>

                        <Link className="btn btn-outline btn-primary btn-sm mx-2" to="projects">Explore Projects</Link>
                        <a href={myresume} className="btn btn-outline btn-secondary btn-sm" download> Download Resume</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;